// extracted by css-extract-rspack-plugin
export default {"course-content":"xQokF9f___course-content","courseContent":"xQokF9f___course-content","logo":"s3wBkOo___logo","title":"hSieHfF___title"};